module.exports = __webpack_public_path__ + "static/media/breakfast.910bb34b.jpg";